import type { ReactNode } from 'react';

interface DrawerSectionTitleProps {
  children: ReactNode;
}

export const DrawerSectionTitle = ({ children }: DrawerSectionTitleProps) => (
  <h3 className="text-info-400 mb-2 flex flex-row justify-between text-xs">{children}</h3>
);
